import type { DestinationConfig, DestinationType } from "./publish-models";

/**
 * Provides default publish config per destination type (from API).
 * Used to seed destination configs when building from destinations list or when a new destination has no saved config.
 */
export abstract class IDestinationTypeDefaultsProvider {
  /** Returns default configs keyed by destination type. Empty record when API returns nothing or errors. */
  abstract getDefaultConfigs(): Promise<Record<DestinationType, DestinationConfig>>;
}
